import React, { useState } from "react"
import MetaTags from "react-meta-tags"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  CustomInput,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Select from "react-select"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

export default function AddNotification() {

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add Notification | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Add Notification" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="NotificationTitle">Notification Title</Label>
                          <AvField
                            name="NotificationTitle"
                            placeholder="NotificationTitle"
                            type="text"
                            className="form-control"
                            id="NotificationTitle"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="UploadImage">Upload Image</Label>
                          <AvField
                            name="UploadImage"
                            placeholder="UploadImage"
                            type="file"
                            className="form-control"
                            id="UploadImage"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="Description">Description</Label>
                          <AvField
                            name="Description"
                            placeholder="Description"
                            type="textarea"
                            className="form-control"
                            id="Description"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    
                    <Button color="primary" type="submit">
                      Submit form
                    </Button>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
